import { useCallback, useState } from "react";

/** @typedef {import("../types").Movie} Movie */

/**
 * Gestión de la lista de favoritos, independiente de qué película esté
 * seleccionada en un momento dado.
 */
export function useFavorites() {
  const [favorites, setFavorites] = useState(/** @type {Movie[]} */ ([]));

  /** @param {number} movieId @returns {boolean} */
  const isFavoriteId = useCallback(
    (movieId) => favorites.some((favorite) => favorite.id === movieId),
    [favorites]
  );

  /** @param {Movie|null} movie */
  const addFavorite = useCallback((movie) => {
    if (!movie) return;

    setFavorites((previousFavorites) =>
      previousFavorites.some((favorite) => favorite.id === movie.id)
        ? previousFavorites
        : [...previousFavorites, movie]
    );
  }, []);

  /** @param {number} movieId */
  const removeFavorite = useCallback((movieId) => {
    setFavorites((previousFavorites) =>
      previousFavorites.filter((favorite) => favorite.id !== movieId)
    );
  }, []);

  return { favorites, isFavoriteId, addFavorite, removeFavorite };
}
